import { Button, Modal } from "@appkit4/react-components";
import { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../services/AuthProvider";
import { getGroupID } from "../services/GroupContext";
import authService from "../services/auth/auth.service";
import sqldatabaseService from "../services/sqldatabase/sqldatabase.service";
import { store } from "../store/store";

const IdleWarnModal = () => {
  const [timerExpired, setTimerExpired] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const auth = useContext(AuthContext);
  const timerRef = useRef(null);

  const clearTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const timerHandler = () => {
    const lastRequest = store.getState().usageInfo.lastRequest;
    // check if last request timestamp is further than x mins in the past
    if (lastRequest) {
      const timeDiff = Date.now() - lastRequest;
      if (timeDiff > 890000) {
        // 15 mins
        // session has ended and user should now be logged out
        logout();
      }
      if (timeDiff > 600000) {
        // 10 mins
        // session is about to end, give user option to refresh the session
        setTimerExpired(true);
      }
    } else {
      setTimerExpired(false);
      clearTimer();
    }
  };

  const refreshUser = async () => {
    const lastRequest = store.getState().usageInfo.lastRequest;
    setIsLoading(true);
    // check if session has already expired
    const timeDiff = Date.now() - lastRequest;
    if (timeDiff > 890000) {
      logout();
    }
    const response = await authService?.refresh();
    if (response?.status === 200) {
      auth?.login(response?.data);
    }
    setTimerExpired(false);
    setIsLoading(false);
  };

  const logout = async () => {
    // clear timer so it doesn't trigger logout again
    setTimerExpired(false);
    clearTimer();
    await sqldatabaseService.postRemoveGroupLock(getGroupID());
    // end the session and revoke the token
    await authService?.logout();
  };

  useEffect(() => {
    timerRef.current = setInterval(timerHandler, 5000);

    return () => {
      clearTimer();
    };
  }, []);

  return (
    <Modal
      initialFocus={false}
      wrapperStyle={{ zIndex: "10000" }}
      title={"You will be logged out soon"}
      ariaLabel={"You will be logged out soon"}
      visible={timerExpired}
      closable={false}
      modalStyle={{ width: "33.75rem" }}
      footerStyle={{ paddingTop: "8px", marginTop: "-8px", minHeight: "64px" }}
      footer={
        <>
          <Button kind="primary" onClick={refreshUser} loading={isLoading}>
            Continue
          </Button>
        </>
      }
    >
      <div>
        <p>Click here to keep working.</p>
      </div>
    </Modal>
  );
};

export default IdleWarnModal;
